import { Dispatch, SetStateAction } from 'react';
import { DatePicker } from '../datePicker.tsx';
import { ClearFiltersButton } from '../clearFiltersButton.tsx';
import { getDefaultScrapFilters, HandledScrapsFilters, ScrapReasonOption, scrapReasonOptions } from './handledScrapFilters.ts';


interface Props {
    filters: HandledScrapsFilters;
    setFilters: Dispatch<SetStateAction<HandledScrapsFilters>>;
}

export function HandledScrapsFilter({
    filters,
    setFilters,
}: Props) {

    function handlePartNumberChange(e: React.ChangeEvent<HTMLInputElement>) {
        setFilters((prevFilters) => {
            const newFilters = { ...prevFilters };
            newFilters.queryFilters.partDisplayName = e.target.value;
            return newFilters;
        });
    }

    function handleOrderNumberChange(e: React.ChangeEvent<HTMLInputElement>) {
        setFilters((prevFilters) => {
            const newFilters = { ...prevFilters };
            newFilters.queryFilters.orderNumber = e.target.value;
            return newFilters;
        });
    }

    function handleStartDateChange(date: Date | null) {
        setFilters((prevFilters) => {
            const newFilters = { ...prevFilters };
            newFilters.queryFilters.startDate = date;
            return newFilters;
        });
    }

    function handleEndDateChange(date: Date | null) {
        setFilters((prevFilters) => {
            const newFilters = { ...prevFilters };
            newFilters.queryFilters.endDate = date;
            return newFilters;
        });
    }

    function handleScrapReasonToggle(scrapReason: ScrapReasonOption) {
        setFilters((prevFilters) => {
            const newFilters = { ...prevFilters };
            if (newFilters.visibleReasons.includes(scrapReason)) {
                newFilters.visibleReasons = newFilters.visibleReasons.filter(it => it !== scrapReason);
            } else {
                newFilters.visibleReasons = [...newFilters.visibleReasons, scrapReason];
            }
            return newFilters;
        });
    }

    function resetFields() {
        setFilters(getDefaultScrapFilters());
    }


    return (
        <div style={{ display: 'flex', flexWrap: 'wrap', alignItems: 'baseline', gap: '16px' }}>
            <div className='flex--horz' style={{ gap: '12px', }}>
                <label>
                    <span style={{ marginRight: '0.4em' }}>Part number:</span>
                    <input
                        style={{ marginLeft: '0.4em' }}
                        type='text'
                        value={filters?.queryFilters?.partDisplayName || ''}
                        onChange={handlePartNumberChange}
                    />
                </label>

                <label>
                    <span style={{ marginRight: '0.4em' }}>Order number:</span>
                    <input
                        style={{ marginLeft: '0.4em' }}
                        type='text'
                        value={filters?.queryFilters?.orderNumber || ''}
                        onChange={handleOrderNumberChange}
                    />
                </label>

                <label>
                    <span style={{ marginRight: '0.4em' }}>Start date:</span>
                    <DatePicker
                        selected={filters?.queryFilters?.startDate || null}
                        onChange={handleStartDateChange}
                        dateFormat='dd.MM.yyyy'
                        className='date-picker'
                    />
                </label>

                <label>
                    <span style={{ marginRight: '0.4em' }}>End date:</span>
                    <DatePicker
                        selected={filters?.queryFilters?.endDate || null}
                        onChange={handleEndDateChange}
                        dateFormat='dd.MM.yyyy'
                        className='date-picker'
                    />
                </label>
            </div>

            <div style={{ display: 'flex', alignItems: 'center', width: '100%' }}>
                <div className='flex--horz' style={{ gap: '12px', justifyContent: 'start' }}>
                    {scrapReasonOptions.map((scrapReason) =>
                        <button
                            key={scrapReason}
                            className={'toggle-button'}
                            style={filters.visibleReasons.includes(scrapReason)
                                ? { backgroundColor: '#008080', color: '#fff' }
                                : { borderColor: '#008080' }}
                            onClick={() => handleScrapReasonToggle(scrapReason)}
                            children={scrapReason}
                        />
                    )}

                    <ClearFiltersButton onClick={() => resetFields()} />

                </div>
            </div>
        </div >
    )
}
